import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import JournalService from 'donor-elf-web/services/journal-service';
import CampaignService from 'donor-elf-web/services/campaign-service';
import type { CampaignsCampaignRouteModel } from 'donor-elf-web/routes/funds/fund/campaigns/campaign';

export default class CampaignsCampaignIndexController extends Controller {
  @service declare campaignService: CampaignService;
  @service declare journalService: JournalService;

  @tracked model!: CampaignsCampaignRouteModel;

  get journals() {
    return this.journalService.journals.filter(
      (j) => j.campaignId === this.model.campaign.id,
    );
  }

  get currentCampaignGoal() {
    return this.campaignService.activeCampaignGoalsByCampaignId[
      this.model.campaign.id
    ];
  }

  get currentCampaignDashboard() {
    return this.currentCampaignGoal?.campaignGoalDashboard;
  }

  get childCampaignGoals() {
    return this.model.campaign.childrenCampaigns.map((childCampaign) => {
      return this.campaignService.activeCampaignGoalsByCampaignId[
        childCampaign.id
      ];
    });
  }
}
